import { Text } from '@akin-home/text/native';

export const JSONText = ({ children }: { children: any }) => (
  <Text>{JSON.stringify(children, null, 3)}</Text>
);
